<template>
  <div>
    <div v-if="useMenu">
      <v-menu
        content-class="mobile-flags-icons"
        bottom
        left
      >
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            style="position: relative; width: 49px"
          >
            <div
              style="margin-right: 9px"
              class="mobile-flag-container"
            >
              <img
                :src="
                  '/img/' +
                  options.filter((option) => option.lang === lang)[0].flag
                "
              />
            </div>
            <i
              style="position: absolute; right: 4px; top: 7px"
              class="fa fa-angle-down"
            />
          </div>
        </template>
        <v-list>
          <template v-for="(option, i) in options">
            <v-list-item
              v-if="option.lang !== lang"
              :key="i"
              @click="clickHandler(option.lang)"
            >
              <v-list-icon>
                <div class="mobile-flag-container">
                  <img :src="'/img/' + option.flag" />
                </div>
              </v-list-icon>
              <v-list-item-title>
                <a class="justify-center">
                  <div
                    style="
                      color: grey;
                      margin-bottom: 0px;
                      padding-left: 12px;
                      float: left;
                      line-height: 24px;
                    "
                  >
                    {{ option.name }}
                  </div>
                </a>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </div>
    <div
      v-else
      :class="className + ' desktop-flags '"
    >
      <div
        v-for="lang in options"
        :key="lang.lang"
        class="flag-container"
      >
        <a @click="clickHandler(lang.lang)"
          ><img
            :src="'/img/' + lang.flag"
            :alt="lang.name"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import sharedMethods from '../../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'Flags',

  props: {
    className: {
      type: String,
      default: null,
    },
    useMenu: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      options: [
        {
          lang: 'et',
          flag: 'est.svg',
          name: 'Eesti',
        },
        {
          lang: 'en',
          flag: 'eng.svg',
          name: 'English (UK)',
        },
        {
          lang: 'fi',
          flag: 'fin.svg',
          name: 'Suomi',
        },
        {
          lang: 'es',
          flag: 'esp.svg',
          name: 'Español',
        },
        {
          lang: 'no',
          flag: 'no.png',
          name: 'Norsk',
        },
        {
          lang: 'sv',
          flag: 'sv.png',
          name: 'Svenska',
        },
        {
          lang: 'nl',
          flag: 'nl.png',
          name: 'Nederlands',
        },
        {
          lang: 'fr',
          flag: 'fr.svg',
          name: 'Français',
        },
        {
          lang: 'da',
          flag: 'da.png',
          name: 'Dansk',
        },
        {
          lang: 'pl',
          flag: 'pl.svg',
          name: 'Polski',
        },
        {
          lang: 'pt',
          flag: 'pt.png',
          name: 'Português',
        },
        {
          lang: 'de',
          flag: 'de.png',
          name: 'Deutsch',
        },
        {
          lang: 'ru',
          flag: 'white-blue-white.png',
          name: 'Русский',
        },
      ],
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),
  },

  methods: {
    ...sharedMethods,

    clickHandler(lang) {
      this.changeLang(lang)
      this.$nextTick(() => {
        if (this.className === 'flags-menu') {
          this.showRightMenu = true
        }
      })
    },
  },
}
</script>

<style lang="scss">
.mobile-flag-container {
  width: 28px;
  height: 28px;
  border: 1px solid grey;
  border-radius: 30px;
  overflow: hidden;

  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  overflow: hidden;
  position: relative;
  img {
    width: auto;
    height: 28px;
    position: absolute;
    top: 50%; /* Center vertically by moving 50% down from the top */
    left: 50%; /* Center horizontally by moving 50% from the left */
    transform: translate(-50%, -50%);
  }
}
.desktop-flags {
  margin-bottom: -5px;
  padding-right: 10px;
  .flag-container {
    width: 28px;
    height: 28px;
    display: inline-grid;
    border: 1px solid grey;
    border-radius: 30px;
    overflow: hidden;
    margin-left: 8px;

    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    overflow: hidden;
    position: relative;
    margin-bottom: 7px;
    img {
      width: auto;
      height: 28px;
      position: absolute;
      top: 50%; /* Center vertically by moving 50% down from the top */
      left: 50%; /* Center horizontally by moving 50% from the left */
      transform: translate(-50%, -50%);
    }
  }
}
</style>
